import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

export type Crumb = { to?: string; label: ReactNode };

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="breadcrumbs" className="flex items-center text-[12px] uppercase tracking-[0.12em] text-muted">
      {items.map((c, i) => {
        const isLast = i === items.length - 1;
        return (
          <Fragment key={i}>
            {c.to && !isLast ? (
              <Link to={c.to} className="hover:text-fg transition-colors">
                {c.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-fg' : ''}>{c.label}</span>
            )}
            {!isLast ? <span className="mx-2 text-border">/</span> : null}
          </Fragment>
        );
      })}
    </nav>
  );
}
